import { Injectable, inject } from '@angular/core';
import { BaseAppSyncService } from '../base-app-sync.service';
import { Observable } from 'rxjs';
import { ReportSapOutage } from '../../model/reporting/report-sap-outage';
import { queryForSapOutages } from '../../graphql/reporting/query-for-sap-outages';
import { SapBuilderService } from '../builder/sap-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportingApiService extends BaseAppSyncService {
  private _sapBuilder = inject(SapBuilderService);

  queryForSapOutages(query: any, sort: any): Observable<ReportSapOutage[]> {
    return this.query(
      queryForSapOutages,
      { query, sort },
      (items: any[]) =>
        items.map((i) => this._sapBuilder.buildReportSapOutage(i)),
      'queryForSapOutages'
    );
  }
}
